export enum Language {
  EN = 'en',
  ES = 'es',
  FR = 'fr',
  DE = 'de',
}

// Data received from Joisst API (Strictly Typed from SSO Spec)
export interface JoisstApiUser {
  userId: string;
  email: string;
  hearts: number;
  brains: number; // New currency
  isAdmin: boolean;
  language: string; // ISO 639-1
  currency: string;
  referralCode: string;
  theme: 'light' | 'dark';
  cookieConsent: boolean;
}

// Local "Database" User Model
export interface LocalUser {
  id: string; // matches Joisst userId
  maskedEmail: string;
  isAdmin: boolean; // Read-only sync from platform
  language: Language;
  referralCode?: string; // Code of the user who referred this one
  createdAt: string;
  lastLoginAt: string;
  cookieConsent: boolean;
  // Add app-specific fields here
  preferences?: Record<string, any>;
}

export interface SessionState {
  user: LocalUser | null;
  apiData: JoisstApiUser | null; // Keep ref to live API data (hearts, etc)
  isLoading: boolean;
  isAuthenticated: boolean;
  language: Language;
  debugMessage?: string; // For troubleshooting auth flow
  themeNotice?: string | null; // Visual confirmation of theme sync
}

export interface TranslationMap {
  [key: string]: string;
}

export interface LocaleData {
  [key: string]: TranslationMap;
}